<template>
  <v-container grid-list-md>
    <v-layout row wrap>
      <v-flex xs12 md6 v-for="orgChart in orgCharts" :key="orgChart.org_chart_id">
        <v-card>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12 >
                <v-card-media
                  :src="orgChart.profile.image"
                  height="200px"
                  contain
                ></v-card-media>
              </v-flex>
              <v-flex xs12 >
                <div class="text-xs-center">
                  <div class="headline">{{ `${orgChart.profile.given_name} ${orgChart.profile.middle_name}. ${orgChart.profile.family_name} ${orgChart.profile.ext_name ? orgChart.profile.ext_name : ''}` }}</div>
                  <div>{{ orgChart.position }}</div>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
export default {
  data(){
    return {
      orgCharts: []
    }
  },
  created(){
    axios.get('/api/about')
      .then(data => {
        this.orgCharts = data.data.org_chart
      }).catch(e => {
        console.log(e)
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/HomePage/About/OrgList.vue